import { CLOUDINARYBASEPATH } from 'constants';

const getPreviewApdStreamVideoSource = videoId => {
  const updatedId = `${videoId.split('.')[0]}.mp4`;
  return `${CLOUDINARYBASEPATH}/video/upload/videos360/${updatedId}`;
};

const getApdStreamVideoSource = (videoId, isPreview) => {
  return isPreview
    ? getPreviewApdStreamVideoSource(videoId)
    : `${CLOUDINARYBASEPATH}/video/upload/sp_c3d_4k_v1/videos360/${videoId}`;
};

const getVideoSource = (videoId, isIOS, maxTextureSize) => {
  const maxDimensions =
    maxTextureSize < 5000 ? `c_limit,w_${maxTextureSize}/` : '';
  const iosPreview = isIOS ? '#t=0.001' : '';
  return `${CLOUDINARYBASEPATH}/video/upload/${maxDimensions}videos360/${videoId}${iosPreview}`;
};

export const get360VideoSource = ({
  videoId = '',
  isPreview = false,
  isIOS = false,
  maxTextureSize = 4096,
}) => {
  const isApdStream = videoId.includes('.m3u8');
  return isApdStream
    ? getApdStreamVideoSource(videoId, isPreview)
    : getVideoSource(videoId, isIOS, maxTextureSize);
};

export const isVideoPreview = (history = {}) => {
  return (
    history.location?.pathname?.includes('medialibrary') ||
    history.location?.pathname?.includes('newstop') ||
    history.location?.pathname?.includes('edit/stop') ||
    history.location?.pathname?.includes('view')
  );
};
